<template lang="pug">
#watch.scrollIntoView.gap-5.d-grid
  EcreativMoleculesTitleSection(
    title="Watch"
    subTitle="Exploring Islam through Multimedia"
  )
  EcreativMoleculesTabsAndSidebar(@tab-click="setSelected")
    template(#tab-featured)
      .videos-grid
        EcreativPlaylistWrapper(:videoList="videoList")
    template(#tab-latest)
      .videos-grid
        EcreativPlaylistWrapper(:videoList="videoList5")
    //- client asked to remove "Most Viewed"
    template(#sidebar)
      EcreativMoleculesSidebar(:title="'Shorts'" :background="'transparent'")
        EcreativPlaylistWrapper(:videoList="videoList3")
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useFetch } from '#app';

type Video = {
  videoId: string;
  title: string;
  subTitle?: string;
  featured?: boolean;
};

const selected = ref('featured');
const setSelected = (tab: string) => {
  selected.value = tab;
};

// --- paste the raw URLs exactly as client sent ---
const featuredUrls = [
  'https://www.youtube.com/watch?v=RUajlk-l5bI',
  'https://www.youtube.com/watch?v=wAEFDzlbifI',
  'https://youtu.be/FbVSPrKV7QI',
  'https://youtu.be/ZaD_P8vv4To',
  'https://www.youtube.com/watch?v=lJo7Y709AR4&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=40&t=1575s&pp=iAQB',
  'https://www.youtube.com/watch?v=jgJNpd5nB6s&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=22&pp=iAQB',
  'https://www.youtube.com/watch?v=Xt9mfEUAgOI&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=58&t=3s&pp=iAQB0gcJCcoJAYcqIYzv',
  'https://www.youtube.com/watch?v=NEFYaYdKPDo&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=67',
  'https://www.youtube.com/watch?v=sU6WK_lP6W8&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=77&pp=iAQB',
  'https://www.youtube.com/watch?v=0nDuaWY8CZg&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=7&pp=iAQB',
  'https://www.youtube.com/watch?v=6w3IBdZxQuo&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=61&pp=iAQB',
  'https://m.youtube.com/watch?v=dPlRyyb-qug&t=1365s',
  'https://m.youtube.com/watch?v=122Vx8xi3_Q&t=254s',
  'https://m.youtube.com/watch?v=SmIWdXqzHMA&t=2s',
  'https://m.youtube.com/watch?v=_uuaOXonLSk&t=842s',
];

const latestUrls = [
  'https://youtube.com/shorts/tbf3e6QduEk?feature=share',
  'https://www.youtube.com/watch?v=K643NSw84P8&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=1&pp=iAQB',
  'https://www.youtube.com/watch?v=nWYrDdA7hec&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=2&pp=iAQB',
  'https://www.youtube.com/watch?v=DJFQYbug8Ms&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=3&pp=iAQB0gcJCcoJAYcqIYzv',
  'https://www.youtube.com/watch?v=GFJUB60biME&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=4&pp=iAQB',
  'https://www.youtube.com/watch?v=m0laVxkvty8&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=17&pp=iAQB',
  'https://www.youtube.com/watch?v=0nDuaWY8CZg&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=7&pp=iAQB',
  'https://www.youtube.com/watch?v=qbABxymD_Z4&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=8&pp=iAQB',
  'https://www.youtube.com/watch?v=FfgVo0r6yd8&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=9&pp=iAQB',
  'https://www.youtube.com/watch?v=E8dKlGS6TiY&list=PLVlXRYauInrUFWx911Cke6lNQZ20eJkN2&index=19&pp=iAQB',
  'https://m.youtube.com/watch?v=ubP3xx5o6C4',
  'https://m.youtube.com/watch?v=B-wI9ro2SLM&t=4s',
  'https://m.youtube.com/watch?v=FfgVo0r6yd8&t=2s',
];

const latestSidebar = [
  'https://youtube.com/shorts/tbf3e6QduEk?feature=share',
  'https://youtube.com/shorts/Eqms4RoKAZM?feature=share',
  'https://youtube.com/shorts/eRe0Qw7JMdI?feature=share',
  'https://youtube.com/shorts/4xCf6M4gTvg?feature=share',
  'https://youtube.com/shorts/Or_2sXvXmbI?feature=share',
];

function extractId(input: string): string | null {
  if (/^[\w-]{11}$/.test(input)) return input;
  try {
    const u = new URL(input);
    const host = u.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') return u.pathname.slice(1) || null;
    if (host.endsWith('youtube.com')) {
      if (u.pathname === '/watch') return u.searchParams.get('v');
      if (u.pathname.startsWith('/embed/'))
        return u.pathname.split('/')[2] || null;
      if (u.pathname.startsWith('/shorts/'))
        return u.pathname.split('/')[2] || null;
    }
  } catch {}
  return null;
}

const featuredIds = Array.from(
  new Set(featuredUrls.map(extractId).filter(Boolean)),
) as string[];

const latestSidebarIds = Array.from(
  new Set(latestSidebar.map(extractId).filter(Boolean)),
) as string[];

const latestIds = Array.from(
  new Set(latestUrls.map(extractId).filter(Boolean)),
) as string[];

const allIds = Array.from(
  new Set([...featuredIds, ...latestIds, ...latestSidebarIds]),
);

// resolve titles on the server (SSRed) so there’s no CORS/flashes
const { data: titlesRes } = await useFetch<{ titles: Record<string, string> }>(
  '/api/youtube/titles',
  {
    method: 'POST',
    body: { ids: allIds },
  },
);
const titleMap = computed(() => titlesRes.value?.titles || {});

// Build lists your wrapper expects
const videoList = computed<Video[]>(() =>
  featuredIds.map((id, i) => ({
    videoId: id,
    title: titleMap.value[id] || 'YouTube Video',
    featured: i === 0, // first item as big/featured
  })),
);

const videoList5 = computed<Video[]>(() =>
  latestIds.map((id) => ({
    videoId: id,
    title: titleMap.value[id] || 'YouTube Video',
  })),
);

/** Keep your existing "Top Videos" sidebar as-is (static) */
const videoList3 = computed<Video[]>(() =>
  latestSidebarIds.map((id) => ({
    videoId: id,
    title: titleMap.value[id] || 'YouTube Video',
  })),
);
</script>

<style lang="scss" scoped>
.videos-grid {
  display: grid;
  gap: 1rem;
  grid-auto-rows: auto;
  position: relative;
  grid-template-columns: 1fr;

  @include media-breakpoint-up(sm) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr);
  }

  :deep(.acople) {
    &.featured {
      height: 100%;
      @include media-breakpoint-up(md) {
        grid-column: span 2;
        grid-row: span 2;
      }
    }
    &:not(.featured) {
      height: 100%;
    }
  }
}
.featured {
  grid-column: span 2;
  grid-row: span 2;
}
</style>
